import React from 'react';
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import BasicDomainItems from "./BasicDomainItems";
import ExpertDomainItems from "./ExpertDomainItems";
import "./BasicDomainInfoForm.css";

const BasicDomainInfoForm = ({
                               fields, handleFieldChange, basicDomainOtherMessage, 
                               expertDomainChecks, handleExpertDomainChecksChange, expertDomainChecksMessage, expertDomainOtherMessage,
                               primaryGames, handlePrimaryGamesChange, primaryGamesMessage, 
                               messages, page, isEdit
                             }) => {
  return (
    <>
     <h3>診療科目</h3>
      <dl>
        <dt>ベーシック領域<span className="red">*</span></dt>
        <dd>
          <Form.Group className="inlineFormSelect inlineFormControl" controlId="basicDomain" size="lg">
            <Form.Control
              as="select"
              custom
              size="sm"
              name="basicDomain"
              value={fields.basicDomain}
              onChange={handleFieldChange}
            >
              <option value="">選択して下さい</option>
              { BasicDomainItems.map((item, index) => (
                  <option value={index+1}>{item}</option>
              ))}
            </Form.Control>
          </Form.Group>
          <Form.Group controlId="basicDomainOther" className="inlineFormControl" size="lg">
            <span className="inlineFdLabel">その他</span>
            <Form.Control
              type="text"
              name="basicDomainOther"
              value={fields.basicDomainOther}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p id="basicDomainMessage" className="errorMessages">{messages.basicDomain.n}</p>
          <p id="basicDomainOtherMessage" className="errorMessages">{messages.basicDomainOther.n}</p>
        </dd>

        <dt>エキスパート領域<span className="red">*</span></dt>
        <dd>
          <Form.Group size="lg">
           <p className="ExpNotice">エキスパート領域を１つ以上（３つまで）選択してください。</p>
           { ExpertDomainItems.map((item, index) => (
            <Form.Check
              custom
              id={ 'expertDomainChecks'+index }
              name={ 'expertDomainChecks'+index }
              label={item}
              type="checkbox"
              value={ index+1 }
              checked={ expertDomainChecks[index] == index + 1 }
              onChange={handleExpertDomainChecksChange}
            />
           ))}
          </Form.Group>
          <p id="expertDomainChecksMessage" className="errorMessages">{expertDomainChecksMessage}</p>
          <p id="expertDomainOtherMessage" className="errorMessages">{expertDomainOtherMessage}</p>
        </dd>

        <dt>主としてサポートしている競技の分類<span className="red">*</span></dt>
        <dd>
          <Table className="senmon03">
            <tbody>
              <tr>
                <td>
                  <Form.Check
                    inline
                    id="primaryGame1"
                    label="ア"
                    type="radio"
                    name="primaryGames"
                    value="1"
                    checked={ 1 == primaryGames }
                    onChange={ handlePrimaryGamesChange }
                  />
                </td>
                <td rowspan="4">個人種目</td>
                <td rowspan="2">ボール</td>
                <td>コンタクト</td>
                <td className="op_event">&nbsp;</td>
              </tr>
              <tr>
                <td>
                  <Form.Check
                    inline
                    id="primaryGame2"
                    label="イ"
                    type="radio"
                    name="primaryGames"
                    value="2"
                    checked={ 2 == primaryGames }
                    onChange={ handlePrimaryGamesChange }
                  />
                </td>
                <td>非コンタクト</td>
                <td className="op_event">テニス、卓球、バドミントン、ゴルフ、ボウリング、スカッシュ、ビリヤードなど</td>
              </tr>
              <tr>
                <td>
                  <Form.Check
                    inline
                    id="primaryGame3"
                    label="ウ"
                    type="radio"
                    name="primaryGames"
                    value="3"
                    checked={ 3 == primaryGames }
                    onChange={ handlePrimaryGamesChange }
                  />
                </td>
                <td rowspan="2">非ボール</td>
                <td>コンタクト</td>
                <td className="op_event">レスリング、ボクシング、剣道、柔道、空手など</td>
              </tr>
              <tr>
                <td>
                  <Form.Check
                    inline
                    id="primaryGame4"
                    label="エ"
                    type="radio"
                    name="primaryGames"
                    value="4"
                    checked={ 4 == primaryGames }
                    onChange={ handlePrimaryGamesChange }
                  />
                </td>
                <td>非コンタクト</td>
                <td className="op_event">陸上、水泳、体操、馬術、アーチェリー、スケート、登山、セイリングなど</td>
              </tr>
              <tr>
                <td>
                  <Form.Check
                    inline
                    id="primaryGame11"
                    label="カ"
                    type="radio"
                    name="primaryGames"
                    value="11"
                    checked={ 11 == primaryGames }
                    onChange={ handlePrimaryGamesChange }
                  />
                </td>
                <td rowspan="4">団体種目</td>
                <td rowspan="2">ボール</td>
                <td>コンタクト</td>
                <td className="op_event">ラグビー、アメフト、サッカー、バスケットボール、ハンドボール、ラクロスなど</td>
              </tr>
              <tr>
                <td>
                  <Form.Check
                    inline
                    id="primaryGame12"
                    label="キ"
                    type="radio"
                    name="primaryGames"
                    value="12"
                    checked={ 12 == primaryGames }
                    onChange={ handlePrimaryGamesChange }
                  />
               </td>
                <td>非コンタクト</td>
                <td className="op_event">野球、バレーボールなど</td>
              </tr>
              <tr>
                <td>
                  <Form.Check
                    inline
                    id="primaryGame13"
                    label="ク"
                    type="radio"
                    name="primaryGames"
                    value="13"
                    checked={ 13 == primaryGames }
                    onChange={ handlePrimaryGamesChange }
                  />
                </td>
                <td rowspan="2">非ボール</td>
                <td>コンタクト</td>
                <td className="op_event">&nbsp;</td>
              </tr>
              <tr>
                <td>
                  <Form.Check
                    inline
                    id="primaryGame14"
                    label="ケ"
                    type="radio"
                    name="primaryGames"
                    value="14"
                    checked={ 14 == primaryGames }
                    onChange={ handlePrimaryGamesChange }
                  />
                </td>
                <td>非コンタクト</td>
                <td className="op_event">ダンス、バレエ、新体操、ボート、綱引きなど</td>
              </tr>
              <tr>
                <td>
                  <Form.Check
                    inline
                    id="primaryGame21"
                    label="サ"
                    type="radio"
                    name="primaryGames"
                    value="21"
                    checked={ 21 == primaryGames }
                    onChange={ handlePrimaryGamesChange }
                  />
                </td>
                <td colspan="3">障がい者スポーツ</td>
                <td className="op_event">すべての障がい者スポーツ</td>
              </tr>
            </tbody>
          </Table>
          <p id="primaryGamesMessage" className="errorMessages">{primaryGamesMessage}</p>
        </dd>
      </dl>
    </>
  );
}

export default BasicDomainInfoForm;
